import * as LessonsV3 from '../../model/v3/lessons';

export class ProductsUtilsV3 {
  public static EN_PRODUCT_LABEL = 'category:lessons.en';
  public static EN_BS_PRODUCT_LABEL = 'category:lessons.en.bs';
  public static SP_PRODUCT_LABEL = 'category:lessons.sp';
  public static EN_CH_PRODUCT_LABEL = 'category:lessons.en.ch';

  public static filterByProductLabel(
    products: LessonsV3.ProductVariantPreview[],
    label: string
  ): LessonsV3.ProductVariantPreview[] {
    return (products ?? []).filter(
      (p) => p?.product?.labels && p.product.labels.indexOf(label) >= 0
    );
  }

  public static filterByVariantLabel(
    products: LessonsV3.ProductVariantPreview[],
    label: string
  ): LessonsV3.ProductVariantPreview[] {
    return (products ?? []).filter(
      (p) => p?.labels && p.labels.indexOf(label) >= 0
    );
  }

  public static orderByOrderLabel(
    products: LessonsV3.ProductVariantPreview[]
  ): LessonsV3.ProductVariantPreview[] {
    const res = (products ?? []).map((p) => {
      let order = 0;
      if (p?.labels) {
        const orderLabel = p.labels.find((l) => l.startsWith('order:'));
        order = Number(orderLabel?.slice('order:'.length) ?? 0);
      }
      return {
        data: p,
        order,
      };
    });
    res.sort((l, r) => l.order - r.order);
    return res.map((d) => d.data);
  }
}
